<template>
  <div
    class="page-bootstrap2"
    :class="'page-bootstrap2-' + state"
    :role="state === 'failed' ? 'alert' : 'status'"
    :aria-busy="busy ? 'true' : 'false'"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="page-bootstrap2-card">
      <span v-if="busy" class="spinner-border" aria-hidden="true"></span>
      <div>
        <strong>{{ title }}</strong>
        <div v-if="message && message !== title" class="page-bootstrap2-message">{{ message }}</div>
        <details v-if="state === 'failed' && reference" class="page-bootstrap2-details">
          <summary>Support details</summary>
          <div>Reference: {{ reference }}</div>
        </details>
      </div>
      <div v-if="state === 'failed'" class="page-bootstrap2-actions">
        <button type="button" class="btn btn-primary" @click="$emit('retry')">Retry</button>
        <button v-if="allowStartNew" type="button" class="btn btn-outline-danger" @click="$emit('start-new')">Start New Order</button>
        <button v-if="allowReturn" type="button" class="btn btn-light" @click="$emit('return-builder')">Return to Builder</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBootstrap2',
  props: {
    state: { type: String, default: 'initializing' },
    message: { type: String, default: '' },
    reference: { type: String, default: '' },
    allowStartNew: Boolean,
    allowReturn: Boolean
  },
  computed: {
    busy () { return this.state === 'initializing' || this.state === 'redirecting' },
    title () {
      if (this.state === 'failed') return 'We could not restore this order.'
      if (this.state === 'redirecting') return 'Taking you to the correct order page…'
      return this.message || 'Restoring your order…'
    }
  }
}
</script>

<style scoped>
.page-bootstrap2 { min-height: calc(100vh - 168px); display: flex; align-items: center; justify-content: center; padding: 24px; color: #36536e; }
.page-bootstrap2-card { width: min(100%, 520px); display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 14px; padding: 28px; border: 1px solid #d8dbe0; border-radius: 10px; background: rgba(255, 255, 255, .96); box-shadow: 0 8px 28px rgba(43, 63, 84, .1); text-align: center; }
.page-bootstrap2-card .spinner-border { width: 1.5rem; height: 1.5rem; color: #2f80ed; }
.page-bootstrap2-message { margin-top: 4px; font-size: 13px; font-weight: 500; }
.page-bootstrap2-details { flex-basis: 100%; font-size: 12px; }
.page-bootstrap2-actions { flex-basis: 100%; display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin-top: 6px; }
@media (max-width: 575px) { .page-bootstrap2 { min-height: calc(100vh - 120px); padding: 16px; } .page-bootstrap2-card { padding: 22px 16px; } }
@media (prefers-reduced-motion: reduce) { .page-bootstrap2 .spinner-border { animation: none; } }
</style>
